import { useState, useEffect } from 'react';
import { Routes, Route, useNavigate, useParams } from 'react-router-dom';
import { Tabs } from '@lk-gtcom/ecomlab-components';
import { AccountSettings } from '../../components/AccountSettings/AccountSettings';
import { AccountNotifications } from '../AccountNotifications/AccountNotifications';
import { Mail } from '../../components/PasswordRecoveryBox/Mail/Mail';
import { AccountSafety } from '../../components/AccountSafety/AccountSafety';
import { ButtonBasic } from '@lk-gtcom/ecomlab-components';
import { PasswordRecoveryPage } from '../PasswordRecoveryPage/PasswordRecoveryPage';
import { TitlePage } from '../../components/TitlePage/TitlePage';
import './AccountManagement.scss';

const btn_tab = [
  { label: 'Мои данные',  value: 'my-details' },
  { label: 'Уведомления', value: 'notifications' },
  { label: 'Безопасность', value: 'safety' },
];

const AccountManagement = ({
  setIsModalActive,
  isModalActive,
  setIsEditSpace,
  setIsModalCreatingNewSpace
}) => {

  const [pageValue, setPageValue] = useState(btn_tab[0].value);
  const path = useParams();
  const navigate = useNavigate();
  const activeTab = useParams()['*'];
  const [showModalPasswordRecovery, setShowModalPasswordRecovery] = useState(false);
  const [showModalChangedPassword, setShowModalChangedPassword] = useState(false);
  const [showModalSendPassword, setShowModalSendPassword] = useState(false);

  const [email, setEmail] = useState('');
  const [changeDataUser, setChangeDataUser] = useState(false);
  const [changePassword, setChangePassword] = useState(false);
  const [valid, setValid] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);

  useEffect(() => {
    if (path['*'] === '') {
      navigate('my-details');
    }
  }, []);

  useEffect(() => {
    setPageValue(activeTab);
  }, [activeTab]);

  return (
    <>
      {showModalPasswordRecovery && (
        <PasswordRecoveryPage
          setIsModal={(e) => setShowModalPasswordRecovery(e)}
        />
      )}

      {showModalSendPassword && (
        <Mail
          text={`На ${email ? 'почту' + email : 'вашу почту'} отправлен пароль`}
          setIsModal={(e) => setShowModalSendPassword(e)}
        />
      )}

      {showModalChangedPassword && (
        <Mail
          title="Пароль успешно изменен"
          text="Вы всегда можете изменить пароль в личном кабинете"
          setIsModal={(e) => setShowModalChangedPassword(e)}
        />
      )}
      
      <div className="account-management">
        <TitlePage
          title='Управление аккаунтом'
        />
        <Tabs tabs={btn_tab} pageValue={pageValue} />
        <div className="account-management__content">
          <Routes>
            <Route
              path="my-details"
              element={
                <AccountSettings
                  setValid={setValid}
                  changeDataUser={changeDataUser}
                  setChangeDataUser={setChangeDataUser}
                />
              }
            />

            <Route
              path="notifications"
              element={
                <AccountNotifications
                  setIsModalActive={setIsModalActive}
                  isModalActive={isModalActive}
                  setIsEditSpace={setIsEditSpace}
                  setIsModalCreatingNewSpace={setIsModalCreatingNewSpace}
                />
              }
            />
            <Route
              path="safety"
              element={
                <AccountSafety
                  changePassword={changePassword}
                  setChangePassword={setChangePassword}
                  setShowModalPasswordRecovery={setShowModalPasswordRecovery}
                  setIsFormValid={setIsFormValid}
                />
              }
            />
          </Routes>
          <div className="group-btn">
            {pageValue != 'notifications' && (
              <ButtonBasic
                blue
                text="Сохранить изменения"
                width="200px"
                onClick={(e) => {
                  if (pageValue === 'my-details') {
                    setChangeDataUser(true);
                  }
                  if (pageValue === 'safety') {
                    setChangePassword(true);
                  }
                }}
                disabled={pageValue === 'my-details' ? !valid : !isFormValid}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export { AccountManagement };
